import { render } from "./pagination_nav.vue?vue&type=template&id=55dc8104"
import script from "./pagination_nav.vue?vue&type=script&lang=js"
export * from "./pagination_nav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/nav/pagination_nav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55dc8104"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55dc8104', __exports__)) {
    api.reload('55dc8104', __exports__)
  }
  
  module.hot.accept("./pagination_nav.vue?vue&type=template&id=55dc8104", () => {
    api.rerender('55dc8104', render)
  })

}


export default __exports__